import { Divider } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { useContext } from 'react';

import { AttributeDefinitionsContext } from '../../AttributeDefinitionsContext';
import FiltersModel from '../modals/FiltersModal';
import DefaultValueFilter from './DefaultValueFilter';
import GlobalFilter from './GlobalFilter';
import IncludeInSearchKeywordsFilter from './IncludeInSearchKeywordsFilter';
import LogSearchDateFilter from './LogSearchDateFilter';
import MandatoryFilter from './MandatoryFilter';
import ReadOnlyFilter from './ReadOnlyFilter';

function Filter({ showPopup, setShowPopup, tabIndex }) {
  const {
    setFilterOpen, resetAllFilters, includeProductCount, setIncludeProductCount, includeInSearchKeywords,
    readOnly, mandatory, defaultValue, globalVal, logsFrom, logsTo,
  } = useContext(AttributeDefinitionsContext);
  const handleDisableApplyButton = () => {
    const filterIncludeProductCount = includeProductCount === false && null;
    const filters = {
      readOnly,
      mandatory,
      defaultValue,
      globalVal,
      filterIncludeProductCount,
      includeInSearchKeywords,
      logsFrom,
      logsTo,
    };
    return Object.values(filters).filter((v) => v !== null).length === 0;
  };

  return (
    <FiltersModel
      open={showPopup}
      onClose={() => setShowPopup(false)}
      applyButtonLabel="APPLY"
      applyButtonOnClick={() => {
        setFilterOpen(false);
        setShowPopup(false);
      }}
      desktopModalWidth={tabIndex === 2 ? '17%' : '40%'}
      resetButtonOnClick={resetAllFilters}
      resetButtonLabel="RESET"
      disableButton={handleDisableApplyButton()}
    >
      <Typography variant="h6" className="text-primary-600">
        Filters
      </Typography>
      <Grid container spacing={2} className="flex-grow" sx={{ mb: 3 }}>
        {(tabIndex === 0 || tabIndex === 1) && (
          <>
            <Grid item xs={12} sm={6}>
              <ReadOnlyFilter />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MandatoryFilter />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DefaultValueFilter />
            </Grid>
            <Grid item xs={12} sm={6}>
              <GlobalFilter />
            </Grid>
            <Grid item xs={12} sm={6}>
              <IncludeInSearchKeywordsFilter />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={includeProductCount}
                    onChange={(e) => setIncludeProductCount(e.target.checked)}
                  />
                )}
                label={<p className="text-primary-600">Include product count</p>}
                className="mr-0"
              />
            </Grid>
          </>
        )}
        {(tabIndex === 2) && (
          <Grid item xs={12} sm={6}>
            <LogSearchDateFilter />
          </Grid>
        )}

      </Grid>
      <Divider orientation="horizontal" sx={{ borderColor: 'primary.main' }} />
    </FiltersModel>
  );
}

export default Filter;
